import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'similar-tours-section';
const BLOCK_ID = 'similar-tours-section';
const PLACEHOLDER_LABEL = 'Ähnliche Reisen';

export default function similarToursSection(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-similar-tours-section') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }

            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: 'Ähnliche Reisen',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-similar-tours',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [{}],
            },
        },
        view: {},
    });
    blockManager.add(BLOCK_ID, {
        label: 'Ähnliche Reisen',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M17 7V4H7v3H4c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h3v2h10v-2h3c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-3ZM9 6h6v3H9V6ZM7 16H4V9h3v7Zm10 3H7v-1h10v1Zm3-3h-3V9h3v7Z"/>
        </svg>`,

        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-similar-tours',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
